import SidebarBookingsIdentityController from 'uplisting-frontend/pods/-sidebar/bookings/identity/controller';

export default class ProtectionOverviewBookingsIdentityController extends SidebarBookingsIdentityController {}
